import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-secondary-50" role="contentinfo">
      <div className="w-full px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <Link to="/" className="flex items-center gap-2 text-foreground-950 no-underline mb-4">
              <div className="w-8 h-8 rounded-lg bg-primary-500 flex items-center justify-center">
                <i className="ri-fire-line text-background-50 text-base"></i>
              </div>
              <span className="font-heading text-lg font-bold tracking-wide whitespace-nowrap">
                吃瓜视频
              </span>
            </Link>
            <p className="text-sm text-foreground-600 leading-relaxed">
              汇聚全网最新最热的吃瓜视频内容，
              <br />
              每日更新猛料，让你吃得过瘾。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-400 uppercase tracking-wider mb-4">
              热门频道
            </h4>
            <ul className="space-y-2.5">
              <li>
                <Link to="/category/mingxing-bagua" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors whitespace-nowrap">
                  明星八卦
                </Link>
              </li>
              <li>
                <Link to="/category/wanghong-dagua" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors whitespace-nowrap">
                  网红大瓜
                </Link>
              </li>
              <li>
                <Link to="/category/tafang-xianchang" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors whitespace-nowrap">
                  塌房现场
                </Link>
              </li>
              <li>
                <Link to="/category/chigua-remen" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors whitespace-nowrap">
                  吃瓜热门
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-400 uppercase tracking-wider mb-4">
              关于本站
            </h4>
            <ul className="space-y-2.5">
              <li>
                <Link to="/about" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors whitespace-nowrap">
                  关于我们
                </Link>
              </li>
              <li>
                <a href="/about#contact" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors whitespace-nowrap">
                  联系我们
                </a>
              </li>
              <li>
                <Link to="/category/chigua-remen" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors whitespace-nowrap">
                  每日猛料
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-400 uppercase tracking-wider mb-4">
              关注我们
            </h4>
            <div className="flex gap-3">
              <a
                href="#"
                className="w-10 h-10 rounded-lg bg-background-200 hover:bg-primary-500 flex items-center justify-center transition-colors duration-200"
                aria-label="微博"
                rel="nofollow"
              >
                <i className="ri-weibo-line text-foreground-700 text-lg"></i>
              </a>
              <a
                href="#"
                className="w-10 h-10 rounded-lg bg-background-200 hover:bg-primary-500 flex items-center justify-center transition-colors duration-200"
                aria-label="微信"
                rel="nofollow"
              >
                <i className="ri-wechat-line text-foreground-700 text-lg"></i>
              </a>
              <a
                href="#"
                className="w-10 h-10 rounded-lg bg-background-200 hover:bg-primary-500 flex items-center justify-center transition-colors duration-200"
                aria-label="抖音"
                rel="nofollow"
              >
                <i className="ri-video-line text-foreground-700 text-lg"></i>
              </a>
              <a
                href="#"
                className="w-10 h-10 rounded-lg bg-background-200 hover:bg-primary-500 flex items-center justify-center transition-colors duration-200"
                aria-label="B站"
                rel="nofollow"
              >
                <i className="ri-bilibili-line text-foreground-700 text-lg"></i>
              </a>
            </div>
          </div>
        </div>
      </div>

      <div className="border-t border-secondary-300/20">
        <div className="w-full px-4 md:px-6 py-10 flex flex-col items-center">
          <div className="font-heading text-6xl md:text-8xl font-bold text-secondary-400/30 tracking-tight select-none mb-6 whitespace-nowrap">
            吃瓜视频
          </div>
          <p className="text-xs text-foreground-500 text-center">
            &copy; {new Date().getFullYear()} 吃瓜视频网 51fuliji.cn &mdash; 版权所有
            &nbsp;&middot;&nbsp;
            <span className="whitespace-nowrap">内容仅供娱乐参考，如有不实信息请联系我们</span>
          </p>
        </div>
      </div>
    </footer>
  );
}